@if (!verify) {
  <div class="reg-screen form-top-section">
    <!-- <div class="mb-0 ng-star-inserted">
    <div class="d-flex justify-content-between"> -->
      <div class="landing-form-back-button-container">
        <a class="" href="javascript:void(0)" (click)="backToLogin()">
          <img src="assets/images/grid-back.png">
        </a>
      </div>
      <div class="landing-form-heading">
        <div class="">
          {{'field.label.sign_up' | translate | async }}
        </div>
        <div class="text-primary">
          <span>1/</span>
          <span style="font-size: 0.8em;">3</span>
        </div>
      </div>
    <!-- </div>
  </div> -->
</div>
<form [formGroup]="registrationForm" (ngSubmit)="registerPatient()" class="mt-4" autocomplete="off">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
      @if (headerInfo?.org_selection_at_self_reg) {
      <div class="floating-input-group c-mb-3">
        <label [ngClass]="headerInfo?.org_selection_at_self_reg?'required':''">{{ 'field.label.facility_name' | translate | async }}</label>
        <kx-multiselect-dropdown #facilitySelector [questions]="facilitySearchSelect.question" [placeholder]="'Select'" [format]="facilitySearchSelect.question.format"
          [settings]="facilitySearchSelect.defaultsetting" [controlName]="facilitySearchSelect" (optionsLoaded)="onDropdownOptionsLoaded($event)"
          [data]="facilitySearchSelect.datasource"  (onSelect)="onSelectFacility($event)">
        </kx-multiselect-dropdown>
      </div>
      }

    <div class="title-name-row">
      @if (titleSearchSelect) {
      <div class="floating-input-group c-mb-3 title-col">
        <label >{{ 'field.label.title' | translate | async }}</label>
        <kx-multiselect-dropdown  [questions]="titleSearchSelect.question" [placeholder]="'Select'" [format]="titleSearchSelect.question.format"
          [settings]="titleSearchSelect.defaultsetting" [controlName]="titleSearchSelect" [data]="titleSearchSelect.datasource"  (onSelect)="onSelectTitle($event)">
        </kx-multiselect-dropdown>
      </div>
      }
    <div class="floating-input-group c-mb-3 name-col">
      <input type="text" formControlName="name_" class="form-control floating-input"
        [ngClass]="{ 'is-invalid': submitted && f.name_.errors }"
        pattern='^[-a-zA-Z-()]+(\s+[-a-zA-Z-()]+)*$' minlength="2" maxlength="50" autofocus required />
      <label for="name_" class="floating-placeholder">{{'field.label.full_name' | translate | async }}</label>
      @if (submitted && f.name_.errors) {
        <div class="input-detail-error form-v2" [popover]="errorTemplate"
          triggers="mouseenter:mouseleave">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
      }
      <ng-template #errorTemplate>
        <div>
          @if (f.name_.errors.required) {
            <div>
            {{'required.user_name' | translate | async }}</div>
          }
          @if (f.name_.errors.minlength) {
            <div>
            {{'validation.minlength.user_name' | translate | async }}</div>
          }
          @if (f.name_.errors.maxlength) {
            <div>
            {{'validation.maxlength.user_name' | translate | async }}</div>
          }
          @if (f.name_.errors.pattern) {
            <div>
            {{'validation.pattern.user_name' | translate | async }}</div>
          }
        </div>
      </ng-template>
    </div>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4 mb-2 p-0">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      @if (headerInfo.enable_telecom_code) {
      <div class="floating-input-group c-mb-3">
        <label [ngClass]="headerInfo?.enable_telecom_code?'required':''">{{ 'field.label.telecom_code' | translate | async }}</label>
        <kx-multiselect-dropdown [questions]="countryCodeSearchSelect.question" [placeholder]="'field.hint.telecom_code' | translate | async" [format]="countryCodeSearchSelect.question.format"
          [settings]="countryCodeSearchSelect.defaultsetting" [controlName]="countryCodeSearchSelect"
          [data]="countryCodeSearchSelect.datasource"  (onSelect)="onSelectTelecomCode($event)">
        </kx-multiselect-dropdown>
        @if (submitted && f.telecom_code.errors?.required) {
          <div class="input-detail-error form-v2" [popover]="telecomCodeError" triggers="mouseenter:mouseleave">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </div>
          <ng-template #telecomCodeError>
            <div>{{ 'required.telecom_code' | translate | async }}</div>
          </ng-template>
        }
      </div>
    }
     </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="floating-input-group c-mb-3">
        <input type="text" formControlName="telecom" placeholder=""
          [ngClass]="{ 'is-invalid': submitted && f.telecom.errors }" required
          class="form-control floating-input" />
        <label for="telecom" class="floating-placeholder">{{'field.label.mobile_number' | translate |
          async
        }}</label>
        @if (submitted && f.telecom.errors) {
          <div class="input-detail-error form-v2"
            [popover]="errorTemplate2" triggers="mouseenter:mouseleave">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </div>
        }
        <ng-template #errorTemplate2>
          <div>
            @if (f.telecom.errors.required) {
              <div>
                {{'required.telecom' | translate | async }}
              </div>
            }
            @if (f.telecom.errors.pattern) {
              <div>
              {{'field.label.mobile_no_regex' | translate | async }}</div>
            }
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
@if (isKarexpert=='karexpert') {
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  mb-2 p-0">
    <div class="floating-input-group">
      <input type="text" formControlName="account_url" class="form-control floating-input"
        [ngClass]="{ 'is-invalid': submitted && f.account_url.errors }" minlength="2" maxlength="255"
        pattern="[aA0-zZ9.-]*" required />
      <label for="account_url" class="floating-placeholder">{{'field.label.account_url' | translate | async
      }}</label>
      @if (submitted && f.account_url.errors) {
        <div class="input-detail-error form-v2"
          [popover]="errorTemplate3" triggers="mouseenter:mouseleave">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
      }
      <ng-template #errorTemplate3>
        <div>
          @if (f.account_url.errors.required) {
            <div>{{'required.account_id' | translate | async }}</div>
          }
          @if (f.account_url.errors.minlength) {
            <div>{{'field.label.account_Url_required' | translate |
              async }}
            </div>
          }
          @if (f.account_url.errors.maxlength) {
            <div>{{'field.label.account_Url_not_exceed' | translate |
              async }}
            </div>
          }
          @if (f.account_url.errors.pattern) {
            <div>{{'field.label.only_alphabet_hyphen_dot_numbers' |
            translate | async }}</div>
          }
        </div>
      </ng-template>
    </div>
  </div>
}
<div class="col-12 p-0 _trm-n-con">
  <label class="kx-check-wrapper m-0">{{'field.label.I_agree_to_the' | translate | async }}
    <input type="checkbox" class="checkbox" formControlName="termscondition" required>
    <span class="kx-check"></span>
  </label>
  <span (click)="showTnc()" style="color: #00ACF1;cursor: pointer;"><strong> {{'field.label.terms_of_service'
  | translate | async }}</strong></span>
  @if (submitted && f.termscondition.errors) {
    <div style="color: #dc3545;">
      @if (f.termscondition.errors.required) {
        <div>{{'field.label.please_accept_terms_of_service' | translate
        | async }}</div>
      }
    </div>
  }
</div>
<div class="col-12 p-0 mt-4">
  <button class="login-button btn-gradient button-hover text-white">
    {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
  aria-hidden="true"></i>
</button>
</div>
</form>
}
@if (verify) {
  <app-otp-varification [compConfig]="otpCompConfig" [data]="registerRes" [fromPage]="fromPage"
    (emitBackEvent)="backToRegistration($event)">
  </app-otp-varification>
}

<div dhs-modal></div>